import React from "react";
import { IAMUserSortField, IIAMUser } from "api/entities/iam-users";
import { IPage, IRequestParams } from "api/entities/page";
import Table, {
  IColumnDefinition,
  TableSelected,
} from "components/shared-ui/table/table";
import styles from "./user-table.module.scss";
import tableStyles from "../../shared-ui/table/table.module.scss";
import { useNavigate } from "react-router-dom";
import { routeUtils } from "utils/route-utils";
import { IIAMEntityRequestParams } from "api/entities/iam-entity";
import { MoreOption } from "components/shared-ui/iam/moreoption";
import { Formatters } from "helper/formatters";

export interface UserTableProps {
  isLoading: boolean;
  page: IPage<IIAMUser>;
  requestParams: IIAMEntityRequestParams<IAMUserSortField>;
  setRequestParams: (data: IIAMEntityRequestParams<IAMUserSortField>) => void;

  selection?: TableSelected<IIAMUser>;
  onSelectionChanged?: (selection: TableSelected<IIAMUser>) => void;
  onSelectAll?: () => void;

  isRowClickable?: boolean;
  hasManageColumn?: boolean;
}

export const IAMUserTable = (props: UserTableProps) => {
  const navigate = useNavigate();
  const columns: IColumnDefinition<IIAMUser, IAMUserSortField>[] = [
    {
      label: "Name",
      className: styles["col--name"],
      formatter: (row) => row.UserName,
      sortKey: IAMUserSortField.UserName,
    },
    {
      label: "ARN",
      className: styles["col--arn"],
      formatter: (row) => row.Arn,
      sortKey: IAMUserSortField.ARN,
    },
    {
      label: "Created At",
      className: styles["col--create-date"],
      formatter: (row) => Formatters.formatDateTime(row.CreateDate),
      sortKey: IAMUserSortField.CreateDate,
    },
    // {
    //   label: "Password Last Used",
    //   className: styles["col--password-last-used"],
    //   formatter: (row) =>
    //     row.PasswordLastUsed
    //       ?  Formatters.formatDateTime(row.PasswordLastUsed)
    //       : "-",
    //   sortKey: IAMUserSortField.LastUsed,
    // },
  ];

   if (props.hasManageColumn) {
      columns.push(
          {
              label: "Manage",
              className: tableStyles["col--manage"],
              formatter: row => (<MoreOption data={row} routeGetter={routeUtils.getRouteToIAMUserDetails}/>),
          });
  }

  return (
    <Table
      testId="iam-user-table"
      columns={columns}
      hideCheckbox={!props.selection}
      loading={props.isLoading}
      rows={props.page.data}
      totalRows={props.page.count}
      onRowClick={(row) =>
        !!props.isRowClickable &&
        navigate(routeUtils.getRouteToIAMUserDetails(row.id))
      }
      selected={props.selection}
      onSetSelected={props.onSelectionChanged}
      onSelectAll={props.onSelectAll}
      responsive
      requestParams={props.requestParams}
      onRequestParamsChanged={props.setRequestParams}
    />
  );
};
